import { TRootState } from "@/store";
import { createSelector } from "reselect";

export const selectSidebar = (state: TRootState) => state.sidebar;

export const selectOpened= createSelector(
  [selectSidebar],
  (sidebar:any) => sidebar.opened
);
